import { render, staticRenderFns } from "./ServiceAlertView.vue?vue&type=template&id=54ebe3a3&scoped=true"
import script from "./ServiceAlertView.vue?vue&type=script&lang=js"
export * from "./ServiceAlertView.vue?vue&type=script&lang=js"
import style0 from "./ServiceAlertView.vue?vue&type=style&index=0&id=54ebe3a3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ebe3a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54ebe3a3')) {
      api.createRecord('54ebe3a3', component.options)
    } else {
      api.reload('54ebe3a3', component.options)
    }
    module.hot.accept("./ServiceAlertView.vue?vue&type=template&id=54ebe3a3&scoped=true", function () {
      api.rerender('54ebe3a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingHistory/components/ServiceAlertView.vue"
export default component.exports